<template>
  <vs-prompt
    title="订单拆单"
    class="break-up-order"
    :active="visible"
    @close="handleCancel"
    buttonsHidden
  >
    <div>
      <div class="title">请在需拆分成新订单的商品中输入拆分数量</div>

      <div class="label">订单1:</div>
      <div>
        <el-table
          :data="tableData"
          class="marTop18"
          :span-method="columnSpanMethod"
          height="245">
          <template v-for="item in finalTableHeader">
            <template v-if="item.code == 'input'">
              <el-table-column
                :fixed="item.fixed ? item.fixed : false" 
                :label="item.name"
                :width="item.width"
                :key="item.code"
              >
                <template slot-scope="scope">
                  <vs-input
                    @mousewheel.prevent
                    class="w-full"
                    v-model="scope.row.input"
                    @input="handleInput(scope.row, scope.$index, true)"
                  />
                </template>
              </el-table-column>
            </template> 
            <!-- 商品名称 -->
            <template v-else-if="item.code == 'skuInfo'">
              <el-table-column :key="item.code" 
                              :fixed="item.fixed ? item.fixed : false"  
                              :label="item.name" 
                              :width="item.width">
                <template slot-scope="scope">
                  <div>{{scope.row.skuName}}</div>
                  <div class="item-tip">{{scope.row.barCode}}</div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="item.code == 'sendSkuInfo'">
              <el-table-column :key="item.code" 
                              :fixed="item.fixed ? item.fixed : false"  
                              :label="item.name"
                              :width="item.width">
                <template slot-scope="scope">
                  <div>{{scope.row.sendSkuName}}</div>
                  <div class="item-tip">{{scope.row.sendSkuBarCode}}</div>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column v-if="item.isStock"
                              :key="item.code" 
                              :label="item.name"
                              :width="item.width">
                <template slot="header">
                  <div class="stock-header">{{item.name}}</div>
                  <div>库存</div>
                </template>
                <template slot-scope="scope">
                  <div :style='getStockStyle(scope.row, scope.$index, item.code, true)'>{{scope.row[item.code]}}</div>
                  <!-- <div :style="scope.row[item.code + 'Class'] ? 'color:#46c93a;': 'color:#ff4757;'">{{scope.row[item.code]}}</div> -->
                </template>
              </el-table-column>
              <el-table-column 
                v-else
                :label="item.name"
                :prop="item.code"
                :width="item.width"
                :fixed="item.fixed ? item.fixed : false"
                :key="item.code">
                </el-table-column>
            </template>
          </template>
        </el-table>
      </div>
      <div class="table-container">
        <div class="label">订单2:</div>
          <el-table
            :data="tableData2"
            class="marTop18"
            :span-method="columnSpanMethod"
            height="245">
          <template v-for="item in finalTableHeader">
            <template v-if="item.code == 'input'">
              <el-table-column
                :fixed="item.fixed ? item.fixed : false" 
                :label="item.name"
                :width="item.width"
                :key="item.code"
              >
                <template slot-scope="scope">
                   {{ scope.row.residueInput }}
                </template>
              </el-table-column>
            </template> 
            <!-- 商品名称 -->
            <template v-else-if="item.code == 'skuInfo'">
              <el-table-column :key="item.code" 
                              :label="item.name" 
                              :width="item.width"
                              :fixed="item.fixed ? item.fixed : false" >
                <template slot-scope="scope">
                  <div>{{scope.row.skuName}}</div>
                  <div class="item-tip">{{scope.row.barCode}}</div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="item.code == 'sendSkuInfo'">
              <el-table-column :key="item.code" 
                              :label="item.name"
                              :width="item.width"
                              :fixed="item.fixed ? item.fixed : false">
                <template slot-scope="scope">
                  <div>{{scope.row.sendSkuName}}</div>
                  <div class="item-tip">{{scope.row.sendSkuBarCode}}</div>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column v-if="item.isStock"
                              :key="item.code"
                              :fixed="item.fixed ? item.fixed : false" 
                              :label="item.name"
                              :width="item.width">
                <template slot="header">
                  <div class="stock-header">{{item.name}}</div>
                  <div>库存</div>
                </template>
                <template slot-scope="scope">
                  <div :style='getStockStyle(scope.row, scope.$index, item.code, false)'>{{scope.row[item.code]}}</div>
                  <!-- <div :style="scope.row[item.code+'Class'] ? 'color:#46c93a;': 'color:#ff4757;'">{{scope.row[item.code]}}</div> -->
                </template>
              </el-table-column>
              <el-table-column 
                v-else
                :label="item.name"
                :prop="item.code"
                :width="item.width"
                :fixed="item.fixed ? item.fixed : false"
                :key="item.code">
                </el-table-column>
            </template>
          </template>
        </el-table>
      </div>

      <div class="footer">
        <vs-button
          color="primary"
          size="small"
          type="filled"
          @click="handleClick"
          >立即拆单</vs-button
        >
      </div>
    </div>
  </vs-prompt>
</template>    

<script>
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { OrderApi } from "@/modules/server-api/commodity-sys/order";
import { validateIntNumber } from '@/utils/validateUtil.js';
import store from '../store.js';
export default {
  components: {
    GcCmpVsTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderNo: {
      type: String,
      default: "",
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    allStockList:{
      type: Array,
      default: () => []
    }
  },
  mixins: [store],
  data() {
    return {
      loading: false,
      tableHeader: [
        {
          name: "下单商品",
          width: "210px",
          code: "skuInfo",
          fixed: "left" 
        },
        {
          name: "下单数量",
          width: "80px",
          code: "orderNum",
          fixed: "left" 
        },
        {
          name: "拆分数量 ",
          width: "100px",
          code: "input",
          fixed: "left"
        },
        {
          name: "发货商品",
          width: "210px",
          code: "sendSkuInfo",
        },
        {
          name: "发货数量",
          width: "100px",
          code: "sendSpecNum",
        },
        {
          name: "总库存",
          width: "100px",
          code: "allStockNum",
        }
      ]  
      // ,
      // freightSpaceHeaders: [
      //   {
      //     name: "",
      //     width: "450px",
      //     key: "locName",
      //   },
      //   {
      //     name: "实际库存",
      //     width: "250px",
      //     key: "actualAmount",
      //   },
      //   {
      //     name: "可用库存",
      //     width: "250px",
      //     key: "availableAmount",
      //   },
      // ],

      // freightSpaces: [],
    };
  },

  computed: {
    tableData2() {
      let tableData2 = JSON.parse(JSON.stringify(this.tableData));
      tableData2 = tableData2.filter((item, index) => {
        item.residueInput = item.num;
        if(!isNaN(item.input)){
          item.residueInput = item.num - (item.input || 0);
          //变更后的发货数量：[箱, 盒]  
          if(item.split){//两种规格
            let boxUnit = this.orderUnitList[0];
            let finalSendInfo = this.computeSendNum(item, false);
            if(item.unit == boxUnit){ 
              item.sendSpecNum = finalSendInfo[0].specNum;
              item.sendNum = finalSendInfo[0].num;   
            }else{//盒
              item.sendSpecNum = finalSendInfo[1].specNum;
              item.sendNum = finalSendInfo[1].num;   
            }
          }else{
            item.sendSpecNum = item.residueInput + item.unit;
            item.sendNum = item.residueInput;
          }
        }  
        return item.residueInput;
      });
      return tableData2;
    },
    finalTableHeader(){
      let extraHead = [];
      this.allStockList.map(item =>{
        let obj = {};
        obj.code = item.id;
        obj.name = item.title;
        obj.isStock = true;
        obj.width = '130px';
        extraHead.push(obj);
      });
      return this.tableHeader.concat(extraHead);

    }
  },
  methods: {
    handleCancel() {
      this.tableData = []
      this.$emit("update:visible", false);
    },  

    handleInput(data, index, sTable, attrName) {
      //去除上下箭头需校验
      attrName = attrName ? attrName : 'input';
      if(!data[attrName] || data[attrName] == ''){
        data[attrName] = 0;
        return false;

      }else if(!validateIntNumber(data[attrName])){
        this.$notifyError("请输入数字");
        return false;
      }
      if (+data[attrName] < 0) {
        data[attrName] = 0;
      } else if (data[attrName] > data.num) {
        data[attrName] = data.num;
      } else {
        data[attrName] = data[attrName] ? parseInt(data[attrName]) : data[attrName];
      }  
      //变更后的发货数量：[箱, 盒]  
      if(data.split ){//两种规格
        let boxUnit = this.orderUnitList[0];
        let finalSendInfo = this.computeSendNum(data, true);
        console.log('===finalSendInfo====', finalSendInfo);
        if(data.unit == boxUnit){//箱
          // data.sendSpecNum = finalSendInfo[0];
          // this.tableData[index+1].sendSpecNum = finalSendInfo[1];    
          data.sendSpecNum = finalSendInfo[0].specNum;
          data.sendNum = finalSendInfo[0].num;
          this.tableData[index+1].sendSpecNum = finalSendInfo[1].specNum; 
          this.tableData[index+1].sendNum = finalSendInfo[1].num; 
        }else{//盒
          // data.sendSpecNum = finalSendInfo[1];
          // this.tableData[index+1].sendSpecNum = finalSendInfo[0];
          data.sendSpecNum = finalSendInfo[1].specNum;
          data.sendNum = finalSendInfo[1].num;
          this.tableData[index+1].sendSpecNum = finalSendInfo[0].specNum; 
          this.tableData[index+1].sendNum = finalSendInfo[0].num; 
        }
        //为计算第二行数据的时候使用
        this.tableData[index+1][attrName] = data[attrName];
      }else{
        data.sendSpecNum = data[attrName] + data.unit;
      }
    },
    //动态计算发货数量:
    computeSendNum(data, sTable){
      //更新发货数量
      let currInput = sTable ? data.input : data.residueInput;
      const boxSpec = Number(data.boxSpec);//箱规
      let finalBoxSendSku = {};
      let finalUnitSendSku = {};
      
      if(boxSpec){
        let boxUnit = this.orderUnitList[0];

        const boxNum = parseInt(currInput / boxSpec);//箱
        finalBoxSendSku.num = boxNum;
        finalBoxSendSku.specNum = boxNum + boxUnit;

        const unitNum = currInput % boxSpec; //盒  
        finalUnitSendSku.num = unitNum;
        finalUnitSendSku.specNum = unitNum + this.orderUnitList[1];
      }
      return [finalBoxSendSku, finalUnitSendSku];
    },
    handleClick() {
      let breakupFlag = false;
      let data = [];
      this.tableData.map((item) => {
        if (item.input) breakupFlag = true;
        //只取合并单元格的第一条数据和只有一条数据的
        if(item.split < 2){
          data.push({
            skuCode: item.skuCode,
            amount: item.input || 0,
            orderType: item.orderType
          });
        }
      });

      if (!breakupFlag) {
        this.$notifyError("请先配置拆分数量");
        return;
      }

      if(!this.tableData2.length){
        this.$notifyError("未拆分出新订单，请检查拆分数量配置");
        return;
      }
      OrderApi.splitOrder({
        orderNo: this.orderNo,
        detail: data,
      }).then(res => {
        if (res.succ == 1) {
          this.$emit("success")
          this.$emit("update:visible", false);
        } else {
          this.$notifyError(res.error);
        }
      })
    },
    //计算库存是否充足
    getStockStyle(row, index, currStockId, sTable){
      let isFit = false;
      const cSendNum = Number(row.sendNum);
      let stockNum = row[currStockId];
      if(stockNum.indexOf('/') != -1){
        const availableAmount = row[currStockId].split('/')[0];
        if(row.split){// 合并
          if(row.split == 2){
            const firstRow = sTable ? this.tableData[index-1] : this.tableData2[index-1];
            const firstRowSendNum =  firstRow.sendNum;
            const firstRowAvaAmount =  firstRow[currStockId].split('/')[0];
            if(Number(availableAmount) >= Number(cSendNum) && Number(firstRowAvaAmount) >= Number(firstRowSendNum)){
              isFit = true;
            }
          }
        }else{  
          if(Number(availableAmount) >= Number(cSendNum)){
            isFit = true;
          }
        } 
      }  
      if(isFit){
        return 'color:#46c93a;';
      }else{
        return 'color:#ff4757';
      }
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.break-up-order {
  .title {
    font-size: 12px;
  }
  .label {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 600;
  }
  .span-line {
    display: flex;
    & /deep/ .el-popover__reference-wrapper {
      margin-left: 2px;
    }
  }
  & /deep/ .vs-dialog {
    min-width: 80%;
    height: 700px;
    min-height: 500px;
  }
  & /deep/ .vs-input--input {
    padding: 2px 4px !important;
  }
  /deep/ .vs-dialog .vs-table--content {
    height: 200px !important;
  }
  .footer {
    text-align: right;
  }
  /deep/ .el-table td, /deep/ .el-table th {
    padding: 0;
    font-size: 12px;
  }
  /deep/ .el-table th{
    color: #626262;
    font-weight: bold;
  }
  .item-tip{
    font-size: 12px;
    color: #aaa;
  }  
  .stock-header{
    text-align: left;
  }
}

.popover-container {
  max-height: 500px;
  overflow: auto;
  & /deep/ .vs-con-table .vs-con-tbody .vs-table--tbody-table {
    font-size: 12px;
    padding: 0;
  }
}
</style> 
